import { cn } from '@/lib/utils';

interface BrandMarkProps {
  /** Render only the glyph, without the "Aelo" wordmark. */
  iconOnly?: boolean;
  /**
   * Анимация сигнала: волны из кольца и дышащая точка. Включается только пока
   * идёт работа — классы `.boot-signal`/`.boot-signal-dot` объявлены в
   * index.html и общие со сплешем, чтобы движение не обрывалось на handoff'е.
   * Вне этой страницы (другой HTML-вход, jsdom) стилей нет, и марка просто
   * стоит. Узел волн смонтирован всегда: выключение — затухание классом
   * `--idle`, а не исчезновение посреди расширения.
   */
  signal?: boolean;
  className?: string;
}

/**
 * Aelo brand mark — the ringed-dot glyph plus the "Aelo" wordmark.
 * Single source for the standalone wordmark (Grow2.ai is the maker brand,
 * shown separately where needed). Used on the sign-in screen; sizing is the
 * hero variant.
 */
export function BrandMark({
  iconOnly = false,
  signal = false,
  className,
}: BrandMarkProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-border bg-bg-surface">
        <div className="absolute inset-1.5 rounded-full border border-primary" />
        <div
          className={cn(
            'boot-signal-dot h-2 w-2 rounded-full bg-primary',
            signal && 'boot-signal-dot--active'
          )}
        />
        <span
          className={cn('boot-signal', !signal && 'boot-signal--idle')}
          aria-hidden="true"
          data-testid="boot-signal"
          data-active={signal}
        />
      </div>
      {!iconOnly && (
        <span className="text-2xl font-bold tracking-wider text-fg">Aelo</span>
      )}
    </div>
  );
}
